import { render, staticRenderFns } from "./InjuryReportEdit.vue?vue&type=template&id=1e7c04e6&"
import script from "./InjuryReportEdit.vue?vue&type=script&lang=ts&"
export * from "./InjuryReportEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports